import LoaderPage from "./LoaderPage";

export default LoaderPage